export default {
  'ActProfileScreen.editProfileButton': {
    en: 'Edit Profile',
    fr: 'Editer le profil',
  },
  'ActProfileScreen.editActButton': { en: 'Edit Act', fr: 'Modifier la loi' },
};
